import { createFileRoute } from "@tanstack/react-router";
import Articles from "@/pages/Articles";
import { fetchLatestArticleLinks } from "@/lib/listingLinks";
import { searchDescriptions } from "@/lib/searchDescriptions";

export const Route = createFileRoute("/articles/")({
  loader: async () => ({ ssrLinks: await fetchLatestArticleLinks(60) }),
  head: () => ({
    meta: [
      { title: "Garden Articles & Guides | Garden-Review" },
      { name: "description", content: searchDescriptions["/articles"] },
      { property: "og:title", content: "Garden Articles & Guides | Garden-Review" },
      { property: "og:description", content: searchDescriptions["/articles"] },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.garden-review.co.uk/articles" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Garden Articles & Guides | Garden-Review" },
      { name: "twitter:description", content: searchDescriptions["/articles"] },
    ],
    links: [{ rel: "canonical", href: "https://www.garden-review.co.uk/articles" }],
  }),
  component: ArticlesRoute,
});

function ArticlesRoute() {
  const { ssrLinks } = Route.useLoaderData();
  return <Articles ssrLinks={ssrLinks} />;
}
